import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    code: null,
    pin: null,
    medPadalaStep: 1,
    balance: 0,
    amount: null,
    appliedCredits: false,
    loading: false,
    errors: null,
    medPadalaCustomization: null,
    milliseconds_date: null
  },
  getters: {
    getField,
    medPadalaLoading: (state) => state.loading,
    medPadalaErrors: (state) => state.errors,
    medPadalaCustomization: (state) => state.medPadalaCustomization,
    medPadalaData: (state) => ({
      code: state.code,
      pin: state.pin,
      amount: state.amount,
      balance: state.balance,
      appliedCredits: state.appliedCredits,
      milliseconds_date: state.milliseconds_date
    })
  },
  mutations: {
    updateField,
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_MEDPADALA_CUSTOMIZATION(state, medPadalaCustomizationData) {
      state.medPadalaCustomization = medPadalaCustomizationData;
    },
    SET_MEDPADALA_DATA(state, data) {
      state.balance = data.balance;
      state.code = data.code;
      state.milliseconds_date = data.milliseconds_date;
    }
  },
  actions: {}
}
